import { render, staticRenderFns } from "./KYCAuth.vue?vue&type=template&id=750326a2&scoped=true"
import script from "./KYCAuth.vue?vue&type=script&lang=js"
export * from "./KYCAuth.vue?vue&type=script&lang=js"
import style0 from "./KYCAuth.vue?vue&type=style&index=0&id=750326a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750326a2",
  null
  
)

export default component.exports